module.exports = __webpack_public_path__ + "img/euro.81ebae3c.svg";